<template>
  <div class="content-container">
    <div class="">
      <div
        ref="reportTableWrapper"
        class="content-box hk-report__table-wrapper"
      >
        <div class="section-box outline">
          <search-comp @onSearch="onSearch" @onReset="onReset">
            <div class="das-form-container">
              <div class="das-form-group">
                <div class="das-form-row">
                  <div class="das-form-col col-3">
                    <div class="das-form-input">
                      <div class="label">{{ $t('field.room') }}</div>
                      <input type="text" />
                    </div>
                  </div>
                  <div class="das-form-col col-3">
                    <div class="das-form-input">
                      <div class="label">{{ $t('field.hotel') }}</div>
                      <el-select
                        v-model="searchParams.hotelIdList"
                        multiple
                        collapse-tags
                        filterable
                        clearable
                        placeholder=""
                      >
                        <el-option
                          v-for="item in hotelOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        />
                      </el-select>
                    </div>
                  </div>

                  <div class="das-form-col col-3">
                    <div class="das-form-input">
                      <div class="label">{{ $t('field.groupService') }}</div>
                      <el-select
                        v-model="searchParams.roomServiceId"
                        filterable
                        clearable
                        placeholder=""
                      >
                        <el-option
                          v-for="item in groupServiceOptions"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        />
                      </el-select>
                    </div>
                  </div>
                </div>
                <div class="das-form-row">
                  <div class="das-form-col col-3">
                    <div class="das-form-input">
                      <div class="label">{{ $t('field.hotel') }}</div>
                      <div class="child-w-80">
                        <CalendarRange
                          v-model="datetimeRange"
                          style="display: block; width: 500px"
                          mode="date"
                          @input="setDateRange"
                        />
                        <!-- @input="setDateRange" -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </search-comp>
          <div class="das-form-container daily-trans-report">
            <div class="das-form-title-container justify-space-between mb-10">
              <div class="das-form-title">
                <span class="main-title">
                  {{ $t('views.report.houseKeepingReport') }}
                </span>
              </div>
              <div class="flex" style="gap: 10px">
                <InfoBtn @click="noteDialogVisible = true" />
                <el-dropdown trigger="click" @command="onClickDropdownItem">
                  <das-button
                    color="primary"
                    size="medium"
                    :rounded="false"
                    outline
                    icon
                  >
                    <i class="el-icon-download"></i>
                  </das-button>
                  <el-dropdown-menu>
                    <el-dropdown-item command="pdf">
                      {{ $t('button.exportPdf') }}
                    </el-dropdown-item>
                    <el-dropdown-item command="excel">
                      {{ $t('button.exportExcel') }}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <!-- <hr /> -->
            <div v-loading="loading" class="daily-trans__list">
              <p
                v-if="dataTable.length == 0"
                style="text-align: center; margin-top: 100px"
              >
                Không có dữ liệu
              </p>
              <el-collapse v-model="collapseNameList" accordion>
                <div
                  v-for="(dailyTrans, index) in dataTable"
                  :key="index"
                  class="daily-trans__item"
                >
                  <el-collapse-item :name="dailyTrans.room_service_id">
                    <template slot="title">
                      <span class="daily-trans__item-header">
                        {{ dailyTrans.room_service_nm }}
                      </span>
                    </template>

                    <div class="grid-scroll" style="height: 350px">
                      <GridVx
                        ref="agGrid"
                        :columns="columns"
                        :rows="dailyTrans.detail"
                        :full-width-cell-renderer="fullWidthCellRenderer"
                        dom-layout="scroll"
                        :default-col-def="defaultColDef"
                        :is-row-selectable="isRowSelectable"
                        class="agGrid daily-trans-synthesis-grid"
                        :auto-size-cell="true"
                      />
                    </div>
                  </el-collapse-item>
                  <div class="daily-trans__item-footer">
                    {{ 'Tổng' }}: {{ $displayCurrency(dailyTrans.total) }}
                  </div>
                  <!-- <div class="daily-trans__item-footer">Tổng: 220000</div> -->
                </div>
              </el-collapse>
            </div>

            <hr style="margin-top: 14px" />
            <div class="total-price">
              Tổng: {{ $displayCurrency(totalMoney) }}
            </div>
          </div>
        </div>
      </div>

      <div class="content-box" style="margin-top: 20px">
        <HKReportPieChart @clickPie="handleClickPie" />
      </div>
      <div class="content-box" style="margin-top: 20px">
        <HKReportHistorgramChart @clickChart="handleClickChart" />
      </div>
    </div>
    <el-dialog
      :title="$t('dialog.titleNote')"
      :visible.sync="noteDialogVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <h3></h3>
          <div class="note-container">
            <h3 class="note-title">Hiển thị tham số</h3>
            <ul>
              <li>
                Minibar : Dịch vụ Minibar, hiển thị theo danh sách các loại dịch
                vụ phát sinh dữ liệu
              </li>
              <li>Số hóa đơn</li>
              <li>Ngày hóa đơn: Ngày tạo hóa đơn</li>
              <li>Mã giá: Mã giá áp dụng cho phòng</li>
              <li>
                Mã đặt phòng: mã đặt phòng phát sinh giao dịch với dịch vụ
                Minibar
              </li>
              <li>Nhân viên tạo: hóa đơn</li>
              <li>Tổng cộng: tổng số tiền của hóa đơn</li>
            </ul>
            <h3 class="note-title">Bảng dữ liệu</h3>
            <ul>
              <li>Mã sản phẩm: Hiển thị mã sản phẩm</li>
              <li>Tên: Hiển thị tên mặt hàng</li>
              <li>Đơn giá: Hiển thị giá đơn vị của dịch vụ</li>
              <li>
                Số lượng: Hiển thị số lượng sản phẩm được sử dụng theo bill
              </li>
              <li>Thành tiền: Hiển thị thành tiền = giá đơn vị * số lượng</li>
              <li>Giảm giá: Hiển thị giảm giá dịch vụ theo giá tổng tiền</li>
              <li>Bao gồm thuế, phí: Hóa đơn đã bao gồm thuế, phí</li>
              <li>
                Tổng tiền giảm giá: tổng số tiền được giảm giá trong tổng tiền
              </li>
              <li>
                Tổng tiền hóa đơn: bằng tổng tiền - tổng tiền giảm giá ( với Phí
                dịch vụ mặc định được quy định theo số tiền , và thuế theo số
                tiền)
              </li>
              <li>Tổng tiền Mini bar ...: tổng tiền của từng loại dịch vụ</li>
              <li>
                Tổng: tổng tiền của tất cả các loại dịch vụ phát sinh giao dịch
              </li>
            </ul>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="noteDialogVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import DasButton from '@/components/ui/DasButton.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import { getAllHotel } from '@/api/hotel.js'
import FullWidthCell from './components/FullWidthCell.vue'
import FullWidthCellTransaction from '../components/FullWidthCellTransaction.vue'
import InfoBtn from '../components/InfoBtn.vue'
import HKReportPieChart from './components/HKReportPieChart.vue'
import HKReportHistorgramChart from './components/HKReportHistorgramChart.vue'
import { hotelOptions } from './stores/hotelListStore'
import {
  getDataHouseKeeping,
  getDataHouseKeepingExcel,
  getRoomService
} from '@/api/report_service/houseKeeperReport'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'

export default {
  components: {
    DasButton,
    CalendarRange,
    // eslint-disable-next-line vue/no-unused-components
    FullWidthCell,
    InfoBtn,
    // eslint-disable-next-line vue/no-unused-components
    FullWidthCellTransaction,
    HKReportPieChart,
    HKReportHistorgramChart
  },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        wrapText: true,
        autoHeight: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      totalMoney: 0,
      loading: false,
      noteDialogVisible: false,
      searchParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        roomId: '',
        roomServiceId: '',
        hotelIdList: []
      },
      defaultSearchParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        roomId: '',
        roomServiceId: '',
        hotelIdList: []
      },
      defaultDatetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      datetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      hotelOptions: hotelOptions,
      groupServiceOptions: [],
      receptionistOptions: [],
      collapseNameList: [],
      columns1: [
        {
          headerName: 'Số hóa đơn',
          field: 'col1',
          sortable: false,
          cellRenderer: params => {
            if (params.data.isPinnedBottom) {
              return `<div style="font-weight: 600">Tổng: ${params.data.col1}</div>`
            } else {
              return params.data.col1
            }
          },
          minWidth: 200
        },
        {
          headerName: 'Ngày hóa đơn',
          field: 'col2',
          sortable: false,
          minWidth: 120,
          maxWidth: 120
        },
        {
          headerName: 'Mã đặt phòng',
          field: 'col3',
          sortable: false,
          minWidth: 100
        },
        {
          headerName: 'Nhân viên tạo',
          field: 'col4',
          sortable: false,
          minWidth: 100
        },
        {
          headerName: 'Số phòng',
          field: 'col5',
          sortable: false,
          minWidth: 100
        },
        {
          headerName: 'Tổng hóa đơn',
          field: 'col6',
          sortable: false,
          minWidth: 100
        },
        {
          headerName: 'Bao gồm thuế phí',
          field: 'col7',
          sortable: false,
          minWidth: 100
        },
        {
          headerName: 'Tổng tiền giảm giá',
          field: 'col8',
          sortable: false,
          minWidth: 100
        },
        {
          headerName: 'Tổng tiền hóa đơn',
          field: 'col9',
          sortable: false,
          minWidth: 100
        },
        {
          headerName: 'Phí dịch vụ',
          field: 'col10',
          sortable: false,
          minWidth: 100
        },
        {
          headerName: 'Thuế GTGT',
          field: 'col11',
          sortable: false,
          minWidth: 100
        }
      ],
      dataTable: [],
      rows1: [],
      columns: [
        // {
        //   headerName: this.$t('grid.column.productCode'),
        //   field: 'product_nm',
        //   // cellClass: "grid-cell-centered",
        //   // width: 100,
        //   sortable: false,
        //   cellRenderer: params => {
        //     if (params.data.isPinnedBottom) {
        //       return `<div style="font-weight: 600">Tổng: ${params.data.col1}</div>`
        //     } else {
        //       return params.data.col1
        //     }
        //   },
        //   minWidth: 200
        // },
        {
          headerName: this.$t('grid.column.productName'),
          field: 'product_nm',
          // cellClass: "grid-cell-centered",
          minWidth: 200,
          flex: 1,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.priceUnit'),
          field: 'product_price',
          valueGetter: params => {
            return this.$displayCurrency(params.data.product_price)
          },
          // cellClass: "grid-cell-centered",
          // width: 100,
          minWidth: 200,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.quantity'),
          field: 'quantity',
          minWidth: 100,

          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.discount'),
          field: 'discount',
          minWidth: 200,
          valueGetter: params => {
            return this.$displayCurrency(params.data.discount)
          },
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false
        },
        {
          headerName: this.$t('grid.column.totalAmount'),
          field: 'price',
          // cellClass: "grid-cell-centered",
          // width: 100,
          valueGetter: params => {
            return this.$displayCurrency(params.data.price)
          },
          minWidth: 200,

          sortable: false
        }
      ],
      rows: [],
      pinnedBottomRowData: [],
      isRowSelectable: node => !node.data.isFullWidthRow,

      groupServiceOptionsCols: []
    }
  },
  beforeMount() {
    this.fullWidthCellRenderer = 'FullWidthCellTransaction'
  },
  mounted() {
    this.getHotelOptions()
    this.getRoomService()
    this.attachData()
  },

  methods: {
    // SELECT OPTIONS
    getHotelOptions() {
      getAllHotel().then(res => {
        this.hotelOptions = Object.assign(this.hotelOptions, res.data)
      })
    },
    getRoomService() {
      getRoomService().then(res => {
        this.groupServiceOptions = res.data
      })
    },
    setDateRange(range) {
      // console.log(range.start, range.end)

      this.searchParams.dateFrom = range.start
      this.searchParams.dateTo = range.end
    },
    tranferData(data) {
      let dataRows = []
      this.collapseNameList = []
      data.forEach(item => {
        let itemRow = {
          room_service_id: item?.room_service_id,
          room_service_nm: item?.room_service_nm,
          total: item?.total_amount,
          detail: []
        }
        item?.invoice.forEach(invoice => {
          itemRow.detail = [
            ...itemRow.detail,
            ...[
              {
                isFullWidthRow: true,
                billNumber: invoice.invoice_num
                  ? invoice.invoice_num
                  : 'Không có số HĐ',
                billDate: invoice?.trading_date,
                bookingCode: invoice?.recode,
                createdBy: invoice?.sale_agent_nm,
                roomNum: invoice?.room_num,
                totalDiscount: invoice?.total_money_discount,
                totalBill: invoice?.total_money_after_discount
              }
            ],
            ...invoice?.product
          ]
        })
        dataRows.push(itemRow)
      })
      if (dataRows.length == 1) {
        this.collapseNameList.push(dataRows[0].room_service_id)
      }
      return dataRows
    },
    async attachData() {
      try {
        this.loading = true
        const data = await getDataHouseKeeping(this.searchParams)
        this.totalMoney = data?.total
        this.dataTable = this.tranferData(data.data)
      } catch (error) {
        const message = error?.response?.data?.message
        this.$message({
          type: 'error',
          message: message ?? 'Đã có lỗi xảy ra'
        })
      } finally {
        this.loading = false
      }
    },

    onSearch() {
      this.attachData()
    },

    onReset() {
      this.searchParams = { ...this.defaultSearchParams }
      this.datetimeRange = { ...this.defaultDatetimeRange }
      this.attachData()
    },

    onClickDropdownItem(cmd) {
      if (cmd == 'excel') {
        getDataHouseKeepingExcel(this.searchParams).then(res => {
          if (res) {
            const date = this.$moment().format('DD-MM-YYYY')
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'buong_phong_report_' + date + '.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
      }
    },
    async handleClickPie(event, searchParamsprop) {
      // console.log(searchParams)
      this.searchParams = { ...this.defaultSearchParams }
      this.datetimeRange = { ...this.defaultDatetimeRange }
      Object.assign(this.searchParams, searchParamsprop)
      this.datetimeRange.start = searchParamsprop.dateFrom
      this.datetimeRange.end = searchParamsprop.dateTo
      this.searchParams.roomServiceId = event?.data?.id
      await this.attachData()

      this.$nextTick().then(async () => {
        await this.$refs.reportTableWrapper.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      })
    },

    async handleClickChart(event) {
      // this.$refs.reportTableWrapper.scrollIntoView({ behavior: 'smooth' })
      // console.log(event, 'check value')
      this.searchParams = { ...this.defaultSearchParams }
      this.datetimeRange = { ...this.defaultDatetimeRange }
      this.searchParams.dateFrom = this.$moment(
        event?.name,
        'DD-MM-YYYY'
      ).format('YYYY-MM-DD')
      this.searchParams.dateTo = this.$moment(event?.name, 'DD-MM-YYYY').format(
        'YYYY-MM-DD'
      )
      this.datetimeRange.start = this.$moment(event?.name, 'DD-MM-YYYY').format(
        'YYYY-MM-DD'
      )
      this.datetimeRange.end = this.$moment(event?.name, 'DD-MM-YYYY').format(
        'YYYY-MM-DD'
      )
      await this.attachData()

      this.$nextTick().then(async () => {
        await this.$refs.reportTableWrapper.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      })
    }
  }
}
</script>

<style></style>

<style lang="scss">
.agGrid {
}

.total-price {
  font-weight: 600;
  text-align: right;
}

.hk-report__wrapper {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 10px;
  // flex-wrap: wrap;
  // flex-direction: column;

  .hk-report__table-wrapper {
    grid-column: 1 / span 1;
  }

  .content-box {
    min-height: 600px;

    &.hk-report__table-wrapper {
      min-height: 800px;
    }
  }
}

@media only screen and (min-width: 1366px) {
  .hk-report__wrapper {
    grid-template-columns: repeat(2, (minmax(0, 1fr)));

    .hk-report__table-wrapper {
      grid-column: 1 / span 2;
    }
  }
}
.daily-trans-report {
  --cell-border-color: rgba(189, 195, 199, 0.5);
  --ag-header-bg: #5f8b76;

  height: 100%;

  .daily-trans__list {
    display: flex;
    flex-direction: column;
    // gap: 20px;
    flex: 1;
    overflow-y: auto;

    .el-collapse {
      border: 0 !important;
    }
  }

  .daily-trans__item {
    .el-collapse-item__header {
      background-color: #357456;
      color: #fff !important;
      border-bottom: 1px solid var(--cell-border-color);
    }

    .el-collapse-item__content {
      padding-bottom: 0;
    }

    &-header {
      font-weight: 600;
      flex: 1;
      font-size: 14px;
      padding: 0 12px;
    }

    &-footer {
      height: 34px;
      line-height: 34px;
      padding: 0 12px;
      background-color: #e7f6e5 !important;
      border-bottom: 1px solid var(--cell-border);
      margin-bottom: 2px;
      font-weight: 500;
      font-size: 14px;
    }

    .grid-scroll {
      // height: 400px;
      // max-height: 400px;
    }

    .daily-trans-synthesis-grid.agGrid {
      .ag-header-viewport {
        background-color: var(--ag-header-bg) !important;
      }

      .header-row,
      .header-row:hover {
        background-color: var(--ag-header-bg) !important;
        color: white;
        font-weight: bold;
      }

      .ag-header-row-column {
        background-color: var(--ag-header-bg) !important;
      }
    }
  }
}
</style>
